import QRCodeVue3 from "qrcode-vue3";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(QRCodeVue3 as any)
})

